import VueRouter from 'vue-router';
import NewDetails from './views/new-details.vue';

const routes = [
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|jeep|alfa-romeo|leapmotor)/new/model/:id/:slug',
        name: 'new-details',
        component: NewDetails,
        props: true,
        meta: {},
    },
];

let scrollBehavior = function(to, from, savedPosition) {
    if (to.hash) {
        return {
            selector: to.hash
            , offset: {x:0, y:105}
        };
    }
    return { selector: 'body', offset: {x:0, y:105} };
};

export default new VueRouter({
    mode: 'history',
    routes,
    base: '/',
    linkActiveClass: 'active',
    scrollBehavior,
});